
<script>

import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import FilterList from '../components/filter-list'
import CrmPessoaForm from './crm-pessoa-form'
import CrmPessoaNovoForm from './crm-pessoa-novo-form'
import CrmFiltrosNegocio from './crm-filtros-negocio'
import { apiDownloadPDF, apiEmailPDF } from '../shared/api-functions'
import { getText, formatDataHoraExtenso } from '../shared/utils'
import { SysVars } from '../main';

export default {
    data () {
        return {
            showFormNovo: false, //exibe a tela de manutencao
            codpessoa: null,
            filter: '',
            textQuery: '',
            statusQuery: '',
            metadata: this.$store.getters.getEntities.metadata,
            selectedFiltro: null,
            selectedUsuario: null,
            selectedEquipe: null,
        }
    },

    components: {
        BarList, BarGrid, FilterList, CrmPessoaNovoForm, CrmPessoaForm, CrmFiltrosNegocio
    },

    computed: {
        pessoaList: function () {
            return this.$store.getters.getPessoaList
        },
    },

    watch: {

    },

    filters: {

    },

    methods: {
        formatDate (value) {
            return formatDataHoraExtenso(value, true)
        },
        handleStyle(color) {
            if (color)
              return 'color: white; background-color: ' + color;
            else 
              return ''
        },
        handleStyleAgenda(obj) {
            if (obj.dias_atividade > 0)
              return 'color: red;';
            else 
            if (obj.dias_atividade < 0)
              return 'color: green;'
            else  
              return ''
        },
        handleChangeUsuario (cod) {
            this.selectedUsuario = cod
            this.loadData()
        },
        handleChangeContatos (cod) {
            this.selectedFiltro = cod
            this.loadData()
        },
        handleChangeEquipe (cod) {
            this.selectedEquipe = cod
            this.loadData()
        },
        handleEdit (codpessoa) {
            //abre a tela de edicao
            this.codpessoa = codpessoa
            this.$modalForm(true)
            // this.$router.push('/crm/pessoa/' + codpessoa)
        },
        handleAction (act, codpessoa) {
            if (act == 1) {
                //print
                //apiDownloadPDF(this, 'print/sales/' + codpessoa)
            } 
        },
        handleNovo () {
            //abre a tela de edicao
            this.codpessoa = null;
            this.showFormNovo = true; //exibe o form de manutencao
            this.$modalForm(true)
        },
        closeForm() {
            this.showFormNovo = false
            this.codpessoa = null;
            this.$modalForm(false)
            // this.$scrollTo(0)
            this.loadData()
        },
        textSearch(value) {
            //efetua a pesquisa por texto
            this.textQuery = 'text=' + value
            this.loadData()
        },
        handleFilterList (status) {
            if (status === 'todos') {
                this.statusQuery = ''
            } else {
                this.statusQuery = 'filtro=' + status
            }
            this.loadData()
        },
        textAtividade (count) {
            if (count == 1)
                return '1 Atividade Atrasada'
            else if (count > 1)
                return count + ' Atividades Atrasadas'
            else
                return ''
        },
        loadData() {
            let query = ''
            if (!this.selectedFiltro || this.selectedFiltro === 0) {
                query = ''
            } else {
                query = 'filtro=' + this.selectedFiltro
            }

            if (this.selectedUsuario) {
              if (query)
                query = query + '&'
              query = query + 'codusuario=' + this.selectedUsuario
            }

            if (this.selectedEquipe) {
              if (query)
                query = query + '&'
              query = query + 'codequipe=' + this.selectedEquipe
            }

            let param = {}
            param.query = ''
            if (query) {
                param.query = query
                if (this.textQuery) {
                     param.query = param.query + '&'
                }
            }
            if (this.textQuery) {
                param.query = param.query + this.textQuery
            } else {
                param.filter = this.filter
            }
            this.$store.dispatch('loadPessoa', param)
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },
    },

    created () {
        this.$store.dispatch('loadConfigCrm', this).then(
            this.loadData()
        )

        // let filters = [
        //     { label: 'Todos os Contatos', qt: null, status: null },
        //     { label: 'Contatos com negócio em aberto', qt: null, status: 'comnegocio' },
        //     { label: 'Contatos com atividade pendente', qt: null, status: 'comagenda' },
        // ]
        // this.paramFilterList = { total: filters, selectedStatus: '' }
        
    }

}

</script>

<template>
    <div>
        <div id="list"> 

            <bar-list
                :refresh-button="true" 
                :new-button="true" 
                :pdf-button="false"
                :xls-button="true"
                single-entity="Contato" 
                plural-entity="Contatos"
                @search="textSearch"
                @new="handleNovo"
                @refresh="loadData">
            </bar-list>

            <div class="mt-2">
                <crm-filtros-negocio :pessoas="true" @changeUsuario="handleChangeUsuario" @changeEquipe="handleChangeEquipe" @changeFiltroContatos="handleChangeContatos"></crm-filtros-negocio>
            </div>  

            <div class="default-container">
                <div v-if="pessoaList.length == 0" class="no-content mb-4">Nenhum contato foi encontrado</div>
                <div class="mainbox" v-for="(pessoa, index) in pessoaList" :key="index">
                    <div class="row p-2">
                        <div class="col-auto text-center">
                            <div class="list-icon">
                                <i class="fa fa-user" aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="col-md-6 col-12">
                            <span class="list-title">{{ pessoa.nome }}</span>
                            <span v-if="pessoa.excluido=='S'" class="badge badge-red ml-2">Excluído</span>
                            <div class="w-100"></div>
                            <span class="lbl-list-detalhe"><i class="fa fa-calendar pr-2" aria-hidden="true"></i> {{ pessoa.data | formatDataHoraExtenso }}</span>
                            <span class="lbl-list-detalhe"><i class="fa fa-user-circle pr-2" aria-hidden="true"></i> {{ pessoa.nome_usuario }}</span>
                            <div class="w-100"></div>
                            <div v-if="pessoa.telefones.length > 0">
                                <span class="lbl-list pr-2" v-for="(fone, index2) in pessoa.telefones" :key="index2"><i class="fa fa-phone pr-2" aria-hidden="true"></i> {{ fone.numero | formatFone }}</span>
                            </div>
                            <div class="w-100"></div>
                            <a v-if="pessoa.organizacao.length>0" class="lbl-list w-100" :href="'#/crm/organizacao/'+pessoa.codorg"><i class="fa fa-university pr-2" aria-hidden="true"></i> {{ pessoa.organizacao[0].nome }}</a>
                            <div v-if="pessoa.count_abertos || pessoa.count_negocios">
                                <label class="lbl-list">Negócios Abertos <span class="lbl-list">{{ pessoa.count_abertos }}</span></label>
                                <label class="lbl-list">Negócios Fechados <span class="lbl-list">{{ pessoa.count_negocios }}</span></label>
                            </div>
                        </div>
                        <div class="col-md-2 col-4">
                            <span v-if="pessoa.tag.length>0" class="tag-input-color mr-3" :style="handleStyle(pessoa.tag[0].cor)" @click="handleEditarPessoa('nome')"> {{ pessoa.tag[0].descricao }} </span>
                        </div>
                        <div class="col-md-2 col-4">
                            <span class="icon icon-atrasado" v-if="pessoa.dias_atividade>0" :title="'Atividade atrasada há ' + pessoa.dias_atividade + ' dias'" data-toggle="tooltip" data-placement="top"><i class="fa fa-calendar" aria-hidden="true"></i></span>
                            <span class="icon icon-sem-agenda" v-if="pessoa.count_agenda == 0" data-toggle="tooltip" data-placement="top" title="Nenhuma atividade"><i class="fa fa-warning" aria-hidden="true"></i></span>
                            <span class="icon icon-agenda" v-if="pessoa.count_agenda > 0 && pessoa.dias_atividade <= 0" data-toggle="tooltip" data-placement="top" title="Atividade planejada"><i class="fa fa-calendar" aria-hidden="true"></i></span>
                            <label class="lbl-list icon-sem-agenda" v-if="!pessoa.proxima_atividade">Sem Atividade</label>
                            <span class="data-list" :style="handleStyleAgenda(pessoa)"> {{ formatDate(pessoa.proxima_atividade) }} </span>
                        </div>
                        <div class="col-auto ml-auto">
                            <bar-grid 
                                :options="{barDefault: true, btnEdit: true}"
                                :moreActions="[]"
                                @edit="handleEdit(pessoa.codpessoa)"
                                @action="handleAction(id, pessoa.codpessoa)">
                            </bar-grid>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <crm-pessoa-novo-form v-if="showFormNovo" :index="this.codpessoa" @closeform="closeForm"></crm-pessoa-novo-form>

        <div class="deal-form-side" v-if="codpessoa">
            <crm-pessoa-form :index="this.codpessoa" @closeform="closeForm"></crm-pessoa-form>
        </div>
    </div>
</template>


<style>

.list-title {
    display: inline-block;
    max-width: 100%;
    /* font-size: 16px; */
    font-weight: 700;
    color: #4993d2;
}

.list-icon {
    font-size: 24px; 
    align-items: center; 
    justify-content: center; 
    background-color: #f5f5f5; 
    border: solid 1px #E0E0E0; 
    box-sizing: border-box; 
    height: 38px; 
    width: 42px; 
    flex-shrink: 0;
}

</style>



// WEBPACK FOOTER //
// src/forms-crm/crm-pessoa-list.vue